import { CardS } from '@atmi/models/cards/card-s';
import { createStore } from '@ngneat/elf';
import {
  addEntities,
  deleteEntities,
  selectAllEntities,
  setEntities,
  updateEntities,
  withEntities
} from '@ngneat/elf-entities';

export const store = createStore({ name: 'beneS' }, withEntities<CardS>());

export const beneS$ = store.pipe(selectAllEntities());

export function setAllS(cards: CardS[]) {
  store.update(setEntities(cards));
}

export function addS(card: CardS) {
  store.update(addEntities(card));
}

export function updateS(id: CardS['id'], card: Partial<CardS>) {
  store.update(updateEntities(id, card));
}

export function deleteS(id: CardS['id']) {
  store.update(deleteEntities(id));
}

